import React from 'react';
import CTSUErrorBoundary from 'components/ErrorBoundary';

function RenderComponent({
  compName, children, permission
}) {
  if (permission === true) {
    return (
      <div className="app-body-center col-12 p-4 bg-white shadow-sm">
        {children}
      </div>
    );
  }
  return (
    <h3>
      You do not have permission to access -
      {compName}
    </h3>
  );
}

function RenderControl(props) {
  return (
    <CTSUErrorBoundary>
      <RenderComponent {...props} />
    </CTSUErrorBoundary>
  );
}

export default RenderControl;
